import React, { useState } from "react"
import { toast } from "react-toastify"
import clsx from "clsx"

import { Button } from "components"
import { moment, thousandSeparator } from "utils"
import { changeContract, extendContract } from "services"
import classes from "./SpCheckout.module.scss"

const SpCheckout = (props) => {
  const {
    setPage,
    contractDetails,
    setContractDetails,
    selectedPlan,
    serviceOwnerWallet,
    extendCurrentContract,
    setCurrentContractSubscriptionPlan
  } = props

  const [sending, setSending] = useState(false)

  const getChangeContractTotalPayableAmount = () => {
    const serviceOwnerWalletBalance =
      Math.max(serviceOwnerWallet.balance, 0)

    const result =
      Math.round(selectedPlan.salePrice + dept - serviceOwnerWalletBalance)

    return Math.max(result, 10000)
  }

  const getExtendContractTotalPayableAmount = () => {
    const serviceOwnerWalletBalance =
      Math.max(serviceOwnerWallet.balance, 0)

    const currentMoment = moment()

    const contractExpiryMoment =
      moment(contractDetails.expiryDate)

    const daysInMonth = 30.4375

    const currentContractTermInMonths =
      contractDetails.term * daysInMonth

    const currentContractCostPerDay =
      contractDetails.salePrice / currentContractTermInMonths

    let contractRemainingTimeInMonths = 0

    if (contractExpiryMoment.isAfter(currentMoment)) {
      contractRemainingTimeInMonths =
        contractExpiryMoment.diff(currentMoment, "days") + 1
    }

    const neededWalletBalance =
      Math.round(
        currentContractCostPerDay * contractRemainingTimeInMonths +
        currentContractCostPerDay * currentContractTermInMonths
      )

    const result =
      Math.round(
        neededWalletBalance +
        dept -
        serviceOwnerWalletBalance
      )

    return Math.max(result, 10000)
  }

  const handleExtendContract = async () => {
    setSending(true)

    try {
      const response = await extendContract()

      if (!!response.gatewayUrl) {
        return window.location.href = response.gatewayUrl
      }

      setContractDetails({ ...response })

      setCurrentContractSubscriptionPlan({ ...selectedPlan })

      setPage("currentPlan")

      toast.success("طرح با موفقیت تمدید شد")
    } catch (err) {
      console.log(err)

      setSending(false)

      toast.error("عملیات انجام نشد")
    }
  }

  const handleChangeContract = async () => {
    setSending(true)

    try {
      const response =
        await changeContract({
          subscriptionPlanId: selectedPlan._id
        })

      if (!!response.gatewayUrl) {
        return window.location.href = response.gatewayUrl
      }

      setCurrentContractSubscriptionPlan({ ...selectedPlan })

      setContractDetails({ ...response })

      setPage("currentPlan")

      toast.success("طرح با موفقیت تغییر کرد")
    } catch (err) {
      console.log(err)

      setSending(false)

      toast.error("عملیات انجام نشد")
    }
  }

  const dept =
    serviceOwnerWallet.balance < 0
      ? Math.abs(serviceOwnerWallet.balance)
      : 0

  const totalPayableAmount =
    extendCurrentContract
      ? getExtendContractTotalPayableAmount()
      : getChangeContractTotalPayableAmount()

  return (
    <div className={classes["container"]}>
      <div className={classes["item"]}>
        <span>موجودی کیف پول</span>

        <b
          className={clsx(
            classes["green"],
            serviceOwnerWallet.balance <= 0 && classes["red"]
          )}
        >
          {thousandSeparator(serviceOwnerWallet.balance)}
        </b>
      </div>

      <div className={classes["item"]}>
        <span>هزینه ی طرح</span>

        <b>{thousandSeparator(selectedPlan.salePrice)}</b>
      </div>

      <div className={classes["item"]}>
        <span>بدهی</span>

        <b className={classes["red"]}>
          {thousandSeparator(dept)}
        </b>
      </div>

      <div className={clsx(classes["item"], classes["total"])}>
        <span>قابل پرداخت</span>

        <b>
          {thousandSeparator(totalPayableAmount)}
        </b>
      </div>

      <div className={classes["footer"]}>
        <Button
          color="success"
          loading={sending}
          onClick={extendCurrentContract
            ? handleExtendContract
            : handleChangeContract
          }
        >
          {extendCurrentContract ? "تمدید اشتراک" : "تغییر اشتراک"}
        </Button>
      </div>
    </div>
  )
}

export default SpCheckout